import React from "react";
import MaxWidthWrapper from "./MaxWidthWrapper";
import NavLink from "./NavLink";
import Button from "./Button";
import Link from "next/link";
import { motion } from "motion/react";
import { scrollToElement } from "@/lib/utils";

const MobileButton = ({ text }: { text: string }) => {
  return (
    <motion.div
      className="bg-primary w-[120px] h-[40px] rounded-[20px] flex items-center justify-center cursor-pointer relative overflow-hidden text-nowrap z-[2] border-[1px] border-dashed border-black"
      initial="initial"
      whileHover="hovered"
      whileTap={{ scale: 0.95 }}
      onClick={() => scrollToElement("marketing-section")}
    >
      <motion.span className="font-editorial text-[18px] tracking-tight text-black z-10 flex mt-1 font-normal">
        {text}
      </motion.span>
      <motion.div
        className="bg-accent absolute size-[200px] rounded-full -z-[1] -bottom-[120px]"
        variants={{
          initial: { scale: 0.2 },
          hovered: { scale: 1 },
        }}
        transition={{
          duration: 0.5,
          ease: [0.87, 0, 0.13, 1],
        }}
      />
    </motion.div>
  );
};

const Navbar = () => {
  return (
    <>
      <MaxWidthWrapper className="bg-white">
        <div className="pt-6 flex justify-between items-center">
          {/* logo placeholder */}
          <Link
            href="/"
            className="bg-primary border border-black border-dashed size-14 rounded-[20px] flex items-center justify-center"
          >
            <span className="text-3xl font-bold font-editorial mt-2">SS</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-7">
            <NavLink text="About me" scrollTo="about-me-section" />
            <Button text="Join waitlist" scrollTo="marketing-section" />
          </div>

          {/* Mobile Navigation */}
          <div className="md:hidden flex items-center pr-2">
            <MobileButton text="Join waitlist" />
          </div>
        </div>
      </MaxWidthWrapper>
    </>
  );
};

export default Navbar;
